<template>
  <main slot="content" id="content" class="content" role="main">
    <router-view></router-view>
  </main>
</template>

<script>
/* eslint-disable */
export default {
  name: 'web-layout',
  created() {

  },
}
</script>
